export type AbstractEnumValue = number | string;

export abstract class AbstractEnum {
  protected static choices: Record<AbstractEnumValue, any> = {};

  public static orderedValues(): number[] {
    return Object.keys(this.choices).map((key) => {
      const numericValue = Number(key);

      return Number.isNaN(numericValue) ? key : numericValue;
    }) as number[];
  }

  public static getValueName(value: any) {
    return this.choices[value] || undefined;
  }

  public static getReadableValues() {
    return this.choices;
  }

  public static getValues(): number[] {
    return this.orderedValues();
  }

  public static getSelectiveOptions() {
    return Object.entries(this.choices).map(([value, label]) => ({
      value: value.toString(),
      label,
    }));
  }
}
